export default __webpack_public_path__ + "static/media/Statistics_2018.71e14634.zip";